import './Loader.css';

const Loader = ({ className = "", inline = false, thin = false }) => {
  const classes = [
    "loader",
    inline ? "loader--inline" : "",
    inline && thin ? "loader--thin" : "",
    inline ? className : "",
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}></div>;
};

export default Loader;
